<template>
  <div class="VideoPage">
    <el-form ref="form" :model="formData" size="mini">
      <el-form-item>
        <template v-if="videoUrl">
          <y-j-video style="width: 400px; height: 200px" :src="videoUrl" />
          <div style="text-align: right; width: 400px">
            <el-button
              class="btn"
              size="mini"
              type="primary"
              @click="handleUploadNew"
              >重新上传
            </el-button>
          </div>
        </template>
        <template v-else>
          <el-upload
            drag
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-change="handleImgChange"
          >
            <i class="el-icon-upload"></i>
            <div>
              <el-button class="btn" size="mini" type="primary" slot="trigger"
                >上传图片
              </el-button>
              <el-button
                class="btn"
                size="mini"
                plain
                type="primary"
                slot="trigger"
                >素材库
              </el-button>
            </div>
          </el-upload>
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addLessonContentMixins } from "@/pages/MyOutLine/addLessonContentMixins";
import { mapActions, mapState } from "vuex";
import YJVideo from "@/components/video/index.vue";

export default {
  name: "VideoPage",
  components: {YJVideo},
  mixins: [addLessonContentMixins],
  data() {
    return {
      videoUrl: "",
    };
  },
  computed: {
    ...mapState("tenant", ["ossUploadObj"]),
  },
  methods: {
    ...mapActions("tenant", ["generalUploadUrl"]),
    beforeUpload(file) {
      if (!file.name.toLowerCase().endsWith("mp4")) {
        this.$message.error("上传视频仅支持mp4格式");
        return false; // 终止上传
      }
    },
    async handleImgChange(file) {
      // this.videoUrl = URL.createObjectURL(file.raw);
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
        .then((res) => {
          this.videoUrl = URL.createObjectURL(file.raw);
          console.log(res);
        })
        .catch((e) => {
          this.$message.error("视频上传失败，请重新上传");
          this.videoUrl = "";
          console.log(e);
        });
      this.$axios.defaults.withCredentials = true;
    },
    handleUploadNew() {
      this.videoUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
